// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"184":"8a48b7a9205de903","421":"9ecc619e7aa47076","954":"3201c9989e408978"}[chunkId] + ".js";
};